import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useSAL2080_R01Store } from "./Store_SAL2080_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_SAL2080_R01 } from "./Content_SAL2080_R01";
import { SearchSection_SAL2080_R01 } from "./SearchSection_SAL2080_R01";
import { Table_SAL2080_R01 } from "./Table_SAL2080_R01";

/**
 * 세금계산서 조회 컨테이너 컴포넌트
 * 세금계산서 조회 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_SAL2080_R01 = () => {
    const { 
        initData, 
        selectedSAL2080_R01List,
        addSelectedSAL2080_R01List,
        removeSelectedSAL2080_R01List
    } = useSAL2080_R01Store();
    const { setMessage } = useUiuxStore();

    // Content에서 액션바 핸들러 함수들을 가져옴
    const {
        fetchData,
        handleExcelClick,
        handlePrintClick,
    } = Content_SAL2080_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} 
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
                onPrintClick={handlePrintClick}
            />
            
            {/* 세금계산서 검색 섹션 */}
            <SearchSection_SAL2080_R01 />
            
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    {/* 세금계산서 테이블 */}
                    <Table_SAL2080_R01 
                        selectedSAL2080_R01List={selectedSAL2080_R01List}
                        addSelectedSAL2080_R01List={addSelectedSAL2080_R01List}
                        removeSelectedSAL2080_R01List={removeSelectedSAL2080_R01List}
                    />
                </div>
            </div>
            
            {/* 메시지 표시 컴포넌트 */}
            <Message />
        </div>
    );
};
